export const createDropdownValuesSlice = (set) => ({
    dropdownValues: null,
    storeDropdownValues: (values) => set({ dropdownValues: values }),
    clearDropdownValues: () => set({ dropdownValues: null }),
});